import React, { useEffect, useState } from 'react';
import { Collapse } from 'antd';
import classNames from 'classnames/bind';
import { useUtils } from 'utils/hooks/useUtils';
import { ICategory } from 'sections/Company/Faqs/types';
import styles from 'sections/Company/Faqs/SectionContent/Questions/QuestionItem/QuestionItem.module.scss';

const cn = classNames.bind(styles);

interface IQuestionsItem {
  item: any;
  action: (id: number) => void;
  isActive: boolean;
  activeQuestionId: number | null;
}

let scrollable = true;

const QuestionItem = ({ item, action, isActive, activeQuestionId }: IQuestionsItem) => {
  const { Panel } = Collapse;
  const { generateQuestionLink } = useUtils();
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [isCopied, setIsCopied] = useState<boolean>(false);

  const copyToClipBoard = (event: any, id: number, subCatId: ICategory) => {
    event.stopPropagation();
    const catId = subCatId.id;
    const questionLink = generateQuestionLink(id, catId);
    navigator.clipboard.writeText(questionLink);
    setIsCopied(true);
  };

  useEffect(() => {
    const hasId = location.href.includes('#');
    if (hasId && scrollable && activeQuestionId && activeQuestionId === item.id) {
      const element = document.getElementById(`${activeQuestionId}`);
      const rect = element?.getBoundingClientRect();
      rect && window.scrollTo(rect.right, rect.top - 10);
      scrollable = false;
    }
  }, []);

  return (
    <div className={cn('question-item')}>
      {/*//@ts-ignore*/}
      <Collapse
        accordion
        ghost
        defaultActiveKey={[activeQuestionId || 0]}
        onChange={() => {
          setIsOpened(!isOpened);
          action(item.id);
        }}
      >
        {/*//@ts-ignore*/}
        <Panel
          key={item.id}
          showArrow={false}
          header={
            <div className={cn('question-item__question', { 'is-active': isActive })}>
              <span className={cn('question-item__text')} id={item.id}>
                {item.name}
              </span>
              <div className={cn('question-item__icons-container')}>
                <button
                  className={cn('question-item__button-copy')}
                  onClick={(event) => copyToClipBoard(event, item.id, item.category_id)}
                >
                  {isCopied ? (
                    <svg
                      className={cn('question-item__icon-success')}
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="check"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path
                        fill="currentColor"
                        d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                      />
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
                      <g clipPath="url(#clip0)">
                        <path
                          opacity="0.4"
                          d="M3.95833 12.25H8.33333V13.3438C8.33333 13.5178 8.26749 13.6847 8.15028 13.8078C8.03306 13.9309 7.87409 14 7.70833 14H0.625C0.45924 14 0.300269 13.9309 0.183058 13.8078C0.065848 13.6847 0 13.5178 0 13.3438L0 3.28125C0 3.1072 0.065848 2.94028 0.183058 2.81721C0.300269 2.69414 0.45924 2.625 0.625 2.625H2.5V10.7188C2.50041 11.1247 2.65419 11.514 2.92759 11.801C3.20099 12.0881 3.57169 12.2496 3.95833 12.25Z"
                          fill="#6E7E92"
                        />
                        <path
                          d="M8.33334 2.84369V-5.90618e-05H3.95834C3.79258 -5.90618e-05 3.63361 0.0690814 3.5164 0.192152C3.39919 0.315223 3.33334 0.482143 3.33334 0.656191V10.7187C3.33334 10.8927 3.39919 11.0597 3.5164 11.1827C3.63361 11.3058 3.79258 11.3749 3.95834 11.3749H11.0417C11.2074 11.3749 11.3664 11.3058 11.4836 11.1827C11.6008 11.0597 11.6667 10.8927 11.6667 10.7187V3.49994H8.95834C8.79273 3.49944 8.63404 3.43013 8.51693 3.30717C8.39983 3.18421 8.33382 3.01758 8.33334 2.84369ZM11.4844 1.99603L9.76563 0.191347C9.70744 0.130458 9.63839 0.0822123 9.56243 0.049369C9.48646 0.0165257 9.40508 -0.000270589 9.32293 -5.90618e-05H9.16668V2.62494H11.6667V2.45924C11.6667 2.28559 11.6011 2.11903 11.4844 1.99603Z"
                          fill="#6E7E92"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect width="11.6667" height="14" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  )}
                </button>
                <svg
                  className={cn('question-item__icon-arrow')}
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="chevron-down"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                >
                  <path
                    fill="currentColor"
                    d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
                  />
                </svg>
              </div>
            </div>
          }
        >
          <div className={cn('question-item__answer')} dangerouslySetInnerHTML={{ __html: item.description }} />
        </Panel>
      </Collapse>
    </div>
  );
};

export { QuestionItem };
